import React from 'react';
import './Message.css';
const MyChat = ({message}) => {

    return (
        <div>
         <h6>No message</h6> 
        </div>
    )
    }
  

export default MyChat;